import React from 'react';
import PropTypes from 'prop-types';

import BtnBase from './base';

const SeeDetails = ({ className, onClick, label }, context) => {
  const getLabel = label || context.t('see details');
  return <BtnBase className={`${className || ''}`} iconAfter={'open-eye'} onClick={onClick} label={getLabel}/>;
};

SeeDetails.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

SeeDetails.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default SeeDetails;
